
<template>
  <v-card style="position:relative;padding-top:65px">
    <v-toolbar
      dark
      color="primary"
      fixed
      style="top:40px;margin:auto;width:800px;left:calc( (100% - 800px)/2 )"
    >
      <v-btn icon dark @click.native="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
      <v-toolbar-title>Editar módulo: {{node.json.modulo.mod_titulo}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items
        v-if="node.json.modulo.mod_titulo != '' && node.json.modulo.mod_tabela != ''"
      >
        <v-btn dark flat @click="gravar()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <form>
      <v-card class="pa-5 ma-2" dark>
        <h3 class="text-xs-left">Informações gerais</h3>
        <v-layout row wrap>
          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="node.json.modulo.mod_titulo"
              :counter="32"
              label="Título"
              required
              hint="(Título da pagina)"
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="node.json.modulo.mod_tabela"
              :counter="32"
              label="Tabela"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="node.json.modulo.mod_paginacao"
              label="Paginação"
              required
              type="number"
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-text-field
              v-model="node.json.modulo.mod_secaomen"
              :counter="32"
              label="Seção de Menu"
              required
            ></v-text-field>
          </v-flex>

          <v-flex xs4 class="pa-1">
            <v-switch
              label="Select"
              v-model="node.json.modulo.mod_numero"
              hint="(se deseja mostrar no inicio a coluna de numero do item) - Seleção com Checkbox"
              persistent-hint
            ></v-switch>
          </v-flex>

          <v-flex xs4 :class="{'pa-1':true, 'greenmod':node.json.modulo.mod_active}">
            <v-switch label="Ativo" v-model="node.json.modulo.mod_active"></v-switch>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <h3 class="text-xs-left">Estrutural</h3>
        <v-layout row wrap>
          <v-flex xs12 class="pa-1">
            <v-select :items="tpls" label="Template" v-model="node.json.modulo.tpl"></v-select>

            <v-textarea
              label
              light
              solo
              v-model="node.json.modulo.tplparam"
              hint="Informação de mapeamento"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2">
        <h3 class="text-xs-left">Ações</h3>
        <v-layout row wrap>
          <v-flex xs3 class="pa-1">
            <v-text-field
              v-model="node.json.modulo.mod_acao_add"
              :counter="32"
              label="Inserir"
              required
              hint
              persistent-hint
            ></v-text-field>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-switch label="Editar" v-model="node.json.modulo.mod_acao_edit"></v-switch>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-switch label="Apagar" v-model="node.json.modulo.mod_acao_del"></v-switch>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-switch label="Visualizar" v-model="node.json.modulo.mod_acao_view"></v-switch>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-text-field v-model="node.json.modulo.mod_fn_add" label="Fn Add" required></v-text-field>
          </v-flex>

          <v-flex xs3 class="pa-1">
            <v-text-field v-model="node.json.modulo.mod_fn_edit" label="Fn Edit" required></v-text-field>
          </v-flex>

          <v-flex xs2 class="pa-1">
            <v-text-field v-model="node.json.modulo.mod_fn_del" label="Fn Del" required></v-text-field>
          </v-flex>

          <v-flex xs2 class="pa-1">
            <v-text-field v-model="node.json.modulo.mod_fn_view" label="Fn View" required></v-text-field>
          </v-flex>

          <v-flex xs2 class="pa-1">
            <v-text-field v-model="node.json.modulo.mod_fn_flow" label="Fn Flow" required></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <h3 class="text-xs-left">Restrição de Listagem</h3>
        <v-layout row wrap>
          <v-flex xs12 class="pa-1">
            <v-textarea
              label="Clausula Where"
              v-model="node.json.modulo.mod_lowhere"
              hint="(clausula WHERE , opcional, da pesquisa para resultados. Permite uso de parametros com [nome]) "
            ></v-textarea>
          </v-flex>

          <v-flex xs12 class="pa-1">
            <v-textarea
              label="Funcionalidades adicionais (JSON) "
              v-model="node.json.modulo.mod_lojson"
              hint
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <h3 class="text-xs-left">Botões de Ação e Join</h3>

        <v-btn color="pink" dark small absolute right fab @click="addTab()">
          <v-icon>add</v-icon>
        </v-btn>

        <v-tabs v-model="tabacao" color="cyan" dark slider-color="yellow" class="elevation-4">
          <v-tab v-for="(n,index) in node.json.custom" :key="index">{{index+1}}</v-tab>
          <v-tab-item class="pa-1" v-for="(n,index) in node.json.custom" :key="index">
            <v-layout row wrap>
              <v-flex xs12 class="pa-1">
                <v-textarea
                  label="Exibe"
                  v-model="n.cus_exibe"
                  hint="funcao que executa no cliente"
                ></v-textarea>
              </v-flex>
              <v-flex xs12 class="pa-1">
                <v-text-field v-model="n.cus_pk" label="Nome" required></v-text-field>

                <v-switch v-model="n.cus_massa" label="Em Massa"></v-switch>
              </v-flex>

              <v-flex xs12 class="pa-1 text-xs-left">
                <v-textarea
                  label="Executa"
                  v-model="n.cus_executa"
                  hint="funcao que executa no server"
                ></v-textarea>

                <a href="javascript:;" class="right" @click="removeAbaAcao(index)">Remover</a>

                <a href="javascript:;" @click="gerarJoin(index, n)">Ligação Join</a> |
                <a href="javascript:;" @click="gerarAcao(index, n)">Ação</a> |
                <a href="javascript:;" @click="gerarAcaoMulti(index, n)">Ação em Massa</a>
              </v-flex>
            </v-layout>
          </v-tab-item>
        </v-tabs>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <h3 class="text-xs-left">Controle CRUD - Funções</h3>
        <v-layout row wrap>
          <template
            v-for="(map,ind) in [
            {   
                nome:'Antes',
                col:'antes',
                hint:''
            },
            {   
                nome:'AoMeio',
                col:'aomeio',
                hint:''
            },
            {   
                nome:'Final',
                col:'final',
                hint:''
            },
            {   
                nome:'Pre-Insert',
                col:'pre_insert',
                hint:''
            },
            {   
                nome:'Pos-Insert',
                col:'pos_insert',
                hint:''
            }, 
            {   
                nome:'Pre-Update',
                col:'pre_update',
                hint:''
            },
            {   
                nome:'Pos-Update',
                col:'pos_update',
                hint:''
            }, 
            {   
                nome:'Pre-Delete',
                col:'pre_delete',
                hint:''
            },
            {   
                nome:'Pos-Delete',
                col:'pos_delete',
                hint:''
            }, 
            {   
                nome:'Pre-Add',
                col:'pre_add',
                hint:''
            },
            {   
                nome:'Pos-Add',
                col:'pos_add',
                hint:''
            }, 
            {   
                nome:'Pre-Edit',
                col:'pre_edit',
                hint:''
            },
            {   
                nome:'Pos-Edit',
                col:'pos_edit',
                hint:''
            }, 
            {   
                nome:'Pre-Pre-View',
                col:'pre_pre_view',
                hint:''
            },            
            {   
                nome:'Pre-View',
                col:'pre_view',
                hint:''
            },
            {   
                nome:'Pos-View',
                col:'pos_view',
                hint:''
            }, 
            {   
                nome:'Pre-Pre-List',
                col:'pre_pre_list',
                hint:''
            },
            {   
                nome:'Pre-List',
                col:'pre_list',
                hint:''
            },
            {   
                nome:'Pos-List',
                col:'pos_list',
                hint:''
            }, 

            
            ]"
          >
            <v-flex xs4 class="pa-1" :key="ind">
              <v-text-field :label="map.nome" v-model="node.json.modulo[map.col]" :hint="map.hint"></v-text-field>
            </v-flex>
          </template>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <h3 class="text-xs-left">Mapeamento de Classe</h3>
        <v-layout row wrap>
          <v-flex xs12 class="pa-1">
            <v-text-field v-model="node.json.modulo.classe" label="Class Name"></v-text-field>
          </v-flex>

          <v-flex xs12 class="pa-1">
            <v-textarea label="Class Display" v-model="node.json.modulo.classe_display"></v-textarea>
          </v-flex>

          <v-flex xs12 class="pa-1">
            <v-textarea label="Class Display Post" v-model="node.json.modulo.classe_post"></v-textarea>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <h3 class="text-xs-left">Extras</h3>
        <v-layout row wrap>
          <v-flex xs6 class="pa-1">
            <v-text-field v-model="node.json.modulo.cache" label="Cache"></v-text-field>
          </v-flex>

          <v-flex xs6 class="pa-1">
            <v-text-field v-model="node.json.modulo.exibicao" label="Exibição"></v-text-field>
          </v-flex>

          <v-flex xs12 class="pa-1">
            <v-textarea
              v-model="node.json.modulo.view_sql"
              placeholder="Views reais no Mysql. Módulo deve inicar com _v_"
              label="View MySQL"
              hint="Ex: select 1 AS `view_version`, id, nome from tabela"
              persistent-hint
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-card>

      <v-card class="pa-3 ma-2" dark>
        <v-btn color="pink" dark small absolute right fab @click="addRod()">
          <v-icon>add</v-icon>
        </v-btn>

        <h3 class="text-xs-left">Rodapé</h3>

        <table border="1" cellpadding="1" class="white black--text">
          <tr>
            <th md-numeric>N</th>
            <th>Nome</th>
            <th>Op</th>
            <th>Coluna</th>
            <th>SQL</th>
            <th>Conta</th>
            <th>Componente</th>
            <th>Param</th>
          </tr>

          <tr v-for="(rod, rodi) in node.json.modulo.rodape" :key="rodi">
            <td md-numeric>
              {{rodi+1}}
              <a href="javascript:;" class="right" @click="removeAbaRod(index)">x</a>
            </td>
            <td dark>
              <v-text-field class="pa-0 ma-1" light v-model="rod.nome" hide-details></v-text-field>
            </td>
            <td dark>
              <v-select
                :items="['SUM','MAX', 'MIN', 'AVG', 'COUNT', 'DIST', '*']"
                hide-details
                light
                v-model="rod.opmode"
              ></v-select>
            </td>
            <td dark>
              <v-text-field class="pa-0 ma-1" light v-model="rod.coluna" hide-details></v-text-field>
            </td>
            <td dark>
              <v-text-field class="pa-0 ma-1" light v-model="rod.sql" hide-details></v-text-field>
            </td>
            <td dark>
              <v-text-field class="pa-0 ma-1" light v-model="rod.conta" hide-details></v-text-field>
            </td>
            <td dark>
              <v-text-field class="pa-0 ma-1" light v-model="rod.componente" hide-details></v-text-field>
            </td>
            <td dark>
              <v-text-field class="pa-0 ma-1" light v-model="rod.componente_param" hide-details></v-text-field>
            </td>
          </tr>
        </table>
      </v-card>
    </form>
  </v-card>
</template>

<script>
/* eslint-disable */

export default {
  props: ["node"],
  data() {
    return {
      tpls: global.appmap.tpls,
      tabacao: 0
    };
  },
  methods: {
    add: function(el) {
      console.log(el);
    },
    addTab() {
      this.node.json.custom.push({
        cus_exibe: "",
        cus_pk: "Nome",
        cus_massa: false,
        cus_executa: ""
      });
      this.tabacao = this.node.json.custom.length - 1;
    },

    addRod() {
      this.node.json.modulo.rodape.push({
        nome: "",
        coluna: "",
        sql: "",
        conta: "",
        opmode: "",
        componente: "",
        componente_param: ""
      });
    },

    removeAbaRod(index) {
      this.node.json.modulo.rodape.splice(index, 1);
    },

    removeAbaAcao(index) {
      this.node.json.custom.splice(index, 1);
    },

    gerarJoin(i, no) {
      let destinonome = window.prompt("Nome?");
      if (destinonome == null) return;
      let destino = window.prompt("Tabela destino?", destinonome.toLowerCase());
      let chaveext = window.prompt(
        "Chave extrangeira?",
        this.node.json.modulo.mod_tabela
      );
      let pkatual = window.prompt("Chave da tabela atual?", "id");
      no.cus_massa = false;
      no.cus_exibe = `
(id, row) => {
    return {
        name: (id, row)=> "${destinonome}" +(row._custom_${chaveext}>0?" (" + row._custom_${chaveext} + ")":"")
        ,
        action: (id, row) => {

            this.navigateToModule('${destino}', {
                    joined: '${chaveext}',
                    joinedid: id,
                    joinedfrom: this.myself.module,
                    joinedsid: this.myself.sid
            });

        },
        html: (id, row)=>null
    };
}`;

      no.cus_pk = destinonome;
      no.cus_executa = `
(id, row) => {
    return {
        query: (conditions) => {
            conditions.attributes.push([global.db.sequelize.literal('(select count(*) from ${destino} where ${destino}.${chaveext} = ${this.node.json.modulo.mod_tabela}.${pkatual})'),'_custom_${chaveext}'])
        }
    };
}`;
    },

    gerarAcao(i, no) {
      let destinonome = window.prompt("Nome?");
      if (destinonome == null) return;

      no.cus_massa = false;
      no.cus_exibe = `
(id, row) => {
    return {
        name: (id, row)=>"${destinonome}",
        action: (id, row) => {
            this.myself.loadingIntra=true;
            this.myself.callAction("${destinonome}", id, {}, (res)=>{
                let result = res.data;
                this.myself.displayAlertBox('Executado com sucesso!')
                this.forceReload();
            },(err)=>{
                this.myself.displayErrorBox(err.response.data.error)
                console.log('error',err)     
            })
        },
        html: (id, row)=>null
    };    
}`;
      no.cus_pk = destinonome;
      no.cus_executa = `
(id, row) => {
    return {
        query: (conditions) => {
        },
        executeServer: async (id,extra) => {
            //Your server code here

            return {
                ok:1
            }
        },
    };
}`;
    },

    gerarAcaoMulti(i, no) {
      let destinonome = window.prompt("Nome?");
      if (destinonome == null) return;

      no.cus_massa = false;
      no.cus_exibe = `
(id, row) => {
   
    return {
        name: (objs, unused)=>"${destinonome}",
        action: (objs, unused) => {

            if(objs.length==0){
                this.myself.displayErrorBox("Nenhum registro selecionado!")
                return;
            }
            this.myself.loadingIntra=true;
            this.myself.callAction("${destinonome}", objs, {}, (res)=>{
                let result = res.data;
                this.myself.displayAlertBox('Executado com sucesso!')
                this.forceReload();
            },(err)=>{
                this.myself.displayErrorBox(err.response.data.error)
                console.log('error',err)     
            })
        },
        html: (objs, unused)=>null
    };
    
}`;
      no.cus_pk = destinonome;
      no.cus_executa = `
(objs, unused) => {
    return {
        query: (conditions) => {
        },
        executeServer: async (objs,extra) => {
            //Your server code here

            return {
                ok:1
            }
        },
    };
}`;
    },

    async gravar() {
      let res = await global.modulosController.updateRest(
        this.node.json.modulo.mod_tabela,
        "forcenew"
      );
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.v-btn {
  margin: 2px;
}
.greenmod {
  background-color: green;
}
</style>
